import produce from 'immer';

const INITIAL_STATE = {
  data: null,
};

export default function turmas(state = INITIAL_STATE, action) {
  return produce(state, draft => {
    switch (action.type) {
      case '@turmas/TURMAS_REQUEST_SUCCESS': {
        draft.data = action.payload.turmas;
        break;
      }
      case '@turmas/TURMAS_REQUEST_FAILURE': {
        draft.data = null;
        break;
      }
      case '@unidade/UNIDADE_SELECIONADA_SUCCESS': {
        draft.data = null;
        break;
      }
      case '@unidade/UNIDADE_SELECIONADA_FAILURE': {
        draft.data = null;
        break;
      }
      case '@auth/SIGN_OUT': {
        draft.data = null;
        break;
      }
      default:
    }
  });
}
